import { ReactElement } from 'react';
import { Font } from 'src/design-system/text/font';
import { Spacer } from 'src/design-system/spacer/Spacer';
// STYLES
import styles from './slice-section.module.scss';
// INTERFACES
import { Link } from '@utmb/design-system/link/link';
import { LinkTypeEnum } from '@utmb/types/enum/LinkTypeEnum';
import { LinkView, SliceSectionView } from 'src/types';
import { Slice } from '@utmb/types/slice-handler';
// UTILS
import { parseMarkdown } from '@utmb/utils/markdown';
import { useGlobal } from '@utmb/contexts/GlobalContext';
import { ColorTypesEnum } from '@utmb/types/colors';
import { useThirdPartyScript } from '@utmb/design-system/use-third-party-script/UseThirdPartyScript';

const { FuturaHeavy, FuturaLight } = Font;

export const Section = (props: Slice<SliceSectionView>): ReactElement => {
    const { id, content, summary, title, links, isDark } = props;
    const scriptContainerId = useThirdPartyScript(content);

    const {
        global: {
            event: { primaryColorIsDark, secondaryColorIsDark },
        },
    } = useGlobal();

    const sectionBlockCSS = [styles.section_block, 'container', isDark ? styles.is_dark : ''].filter(Boolean).join(' ');

    return (
        <div id={id} className={sectionBlockCSS}>
            {title && (
                <FuturaHeavy as="h2" mobile="22" desktop="36">
                    {title}
                </FuturaHeavy>
            )}
            {summary && <FuturaLight mobile={'36'}>{summary}</FuturaLight>}
            {content && (
                <div
                    suppressHydrationWarning
                    className={`${styles.paragraph} lh-24 lh-d-28 markdown ${primaryColorIsDark ? 'primaryColorIsDark' : ''}`}
                    dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
                />
            )}
            <div id={scriptContainerId} style={{ display: 'none' }} />
            {links && !!links.length && (
                <>
                    <Spacer custom="25" />
                    <div className={links.every((link) => link.type === LinkTypeEnum.BUTTON) ? styles.wrapButtonsLinks : ''}>
                        {links.map((link: LinkView) => {
                            const LinkComponent = link.type === LinkTypeEnum.LINK ? Link.Default : Link.Button;

                            const classname = link.type === LinkTypeEnum.LINK ? styles.link : styles.button;

                            return (
                                <LinkComponent
                                    href={link.slug}
                                    className={classname}
                                    label={link.label}
                                    followClassName={`${link.followClass}-ga`}
                                    key={link.slug}
                                    bgcolor={
                                        ((isDark && !secondaryColorIsDark) || (!isDark && secondaryColorIsDark)) && secondaryColorIsDark !== primaryColorIsDark
                                            ? ColorTypesEnum.SECONDARY
                                            : undefined
                                    }
                                />
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
};
